export const submittedToUrlParamsTranslation: { [index: string]: string } = {
  startDate: "fr",
  endDate: "to",
  sortBy: "flt",
  price: "pr",
  tags: "ft",
  travelNumber: "trvlcode",
  pageFrom: "p",
  duration: "du",
};
